import Vue from "vue"

export const PluralizeIfNeededMixin = Vue.extend({
  methods: {
    pluralizeIfNeeded(word: string, count: number) {
      return `${word}${count !== 1 ? "s" : ""}`
    },
  },
})
